import { RouteInfo } from '../vertical-menu.metadata';
export function getAlldata5() {
//Sidebar menu Routes and data
const BUSPROUTES: RouteInfo[] = [
    {
        path: '/Admin/Invoice/Employee-Management/Dashboard', title: 'Dashboard', icon: 'fa fa-tachometer', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },
    {
        path: '/Admin/Invoice/Employee-Management/employeeList', title: 'Employee List', icon: 'fa fa-file-text', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },

    {
        path: '/Admin/Invoice/Employee-Management/employeeLoans', title: 'Employee Loans', icon: 'fa fa-file-text', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
    },


];

return BUSPROUTES
}